module.exports = __webpack_public_path__ + "img/landing-frame-03.d319c163.png";